import React, { Fragment, useRef } from "react";
import Breadcrumb from "../../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { showToast } from "../../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import { StoreCategoryMedicalStore } from "../../../../api/medicalStore/master/categoryMedicalStoreAPI";
import useKeyboardSubmit from "../../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../../hooks/useEnterNavigation";

/* =======================
   Validation Schema
======================= */
const schema = yup.object().shape({
  name: yup.string().required("Category Name is required"),
  gstItemCode: yup.string().required("GST Item Code is required"),
  purchaseAccount: yup.string().required("Purchase Account is required"),
  saleCharge: yup
    .number()
    .typeError("Sale Charge must be a number")
    .required("Sale Charge is required"),
  singleUnitIssue: yup.string().required("Single Unit Issue is required")
});

const AddCategoryMedicalStore = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await StoreCategoryMedicalStore(data);
      if (response.success) {
        showToast("success", response.message);
        navigate(`/medical-store/master/category/list`);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error.message);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  return (
    <Fragment>
      <Breadcrumb parent="Medical Store" title="Add Category" />

      <div className="container-fluid">
        <div className="card">
          <div className="card-header d-flex justify-content-between">
            <h5>Add Category</h5>

            <Link
              to={`${process.env
                .PUBLIC_URL}/medical-store/master/category/list`}
            >
              <button className="btn btn-primary" id="list">
                List Category
              </button>
              <UncontrolledTooltip target="list">
                List Category
              </UncontrolledTooltip>
            </Link>
          </div>

          <form
            ref={formRef}
            className="form theme-form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="card-body">
              <div className="row">
                {/* Category Name */}
                <div className="col-6">
                  <div className="form-group">
                    <label>Category Name</label>
                    <input
                      className="form-control"
                      placeholder="Enter Category Name"
                      {...register("name")}
                    />
                    {errors.name &&
                      <p className="text-danger">
                        {errors.name.message}
                      </p>}
                  </div>
                </div>

                {/* GST Item Code */}
                <div className="col-6">
                  <div className="form-group">
                    <label>GST Item Code</label>
                    <input
                      className="form-control"
                      placeholder="Enter GST Item Code"
                      {...register("gstItemCode")}
                    />
                    {errors.gstItemCode &&
                      <p className="text-danger">
                        {errors.gstItemCode.message}
                      </p>}
                  </div>
                </div>

                {/* Purchase Account */}
                <div className="col-6">
                  <div className="form-group">
                    <label>Purchase Account</label>
                    <input
                      className="form-control"
                      placeholder="Enter Purchase Account"
                      {...register("purchaseAccount")}
                    />
                    {errors.purchaseAccount &&
                      <p className="text-danger">
                        {errors.purchaseAccount.message}
                      </p>}
                  </div>
                </div>

                {/* Sale Charge */}
                <div className="col-6">
                  <div className="form-group">
                    <label>Sale Charge</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Sale Charge"
                      {...register("saleCharge")}
                    />
                    {errors.saleCharge &&
                      <p className="text-danger">
                        {errors.saleCharge.message}
                      </p>}
                  </div>
                </div>

                {/* Single Unit Issue */}
                <div className="col-6">
                  <div className="form-group">
                    <label>Single Unit Issue</label>
                    <select
                      className="form-control"
                      {...register("singleUnitIssue")}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                    {errors.singleUnitIssue &&
                      <p className="text-danger">
                        {errors.singleUnitIssue.message}
                      </p>}
                  </div>
                </div>
              </div>
            </div>

            <div className="card-footer text-end">
              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default AddCategoryMedicalStore;
